<template>
  <div class="els-card-wrapper">
    <div class="els-card">
      <div v-if="!isLoading" class="els-card__body">
        <ELSCardCurrentSession
          :currentLab="currentLab"
          :currentSession="currentSession"
          :setLabStatus="setLabStatus"
          @closeModal="$emit('closeModal')"
          @customLabError="showCustomError"
        />
        <ELSCardGlobalSession
          :currentLab="currentLab"
          :currentSession="currentSession"
        />
      </div>
      <div v-else class="els-card__body">
        <ActionLoader
          loaderClass="els-card__loading-spinner"
          name="ball-clip-rotate"
        />
      </div>
    </div>
    <div class="els-card__error-messages" v-if="customLabError">
      <div class="maintenance-title">
        <MaintenanceRobot class="maintenance-robot-icon" />
        <MaintenanceTool class="maintenance-tool-icon" />
        <span class="maintenance-title__text">Under<br />Maintenance</span>
      </div>
      <div class="maintenance-text">
        <p class="els-card__lab-error">{{ customLabError }}</p>
        <p>
          If the issue is not resolved, please email us at
          <a href="mailto:support@ine.com">support@ine.com</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import ELSCardCurrentSession from '@/components/modals/lab-modal/ELSCardCurrentSession.vue'
import ELSCardGlobalSession from '@/components/modals/lab-modal/ELSCardGlobalSession.vue'
import MaintenanceRobot from '@/assets/icons/course/lab/maintenance-robot.svg'
import MaintenanceTool from '@/assets/icons/course/lab/maintenance-tool.svg'

export default {
  components: {
    ActionLoader,
    ELSCardCurrentSession,
    ELSCardGlobalSession,
    MaintenanceRobot: { ...MaintenanceRobot, name: 'MaintenanceRobot' },
    MaintenanceTool: { ...MaintenanceTool, name: 'MaintenanceTool' },
  },
  props: {
    setLabStatus: {
      type: Function,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
  },
  data: () => {
    return {
      customLabError: '',
    }
  },
  computed: {
    ...mapState({
      currentLab: state => state.labs.currentLab,
      currentSession: state => state.labs.currentLabSession,
    }),
  },
  methods: {
    showCustomError(error) {
      switch (error) {
        case 4001:
          this.customLabError =
            "We're sorry, but this lab is currently under maintenance. Please try another lab or try again in a few minutes."
          break
        case 4002:
          this.customLabError =
            'Our Lab Platform is currently under heavy load and we’re performing some maintenance work, please try again in a few minutes.'
          break
        default:
          this.customLabError = ''
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.els-card-wrapper {
  width: 100%;
}
.els-card {
  width: 100%;
  max-width: 650px;
  min-height: 300px;
  color: var(--white);
  background-color: var(--black);
  display: inline-block;
  border-radius: 10px;
  margin: auto;
  @include tablet {
    display: flex;
  }
  &__body {
    width: 100%;
    flex-grow: 1;
    display: inline-block;
    align-items: center;
    justify-content: center;
    @include tablet {
      display: flex;
    }
  }
  &__error-messages {
    width: 100%;
    max-width: 650px;
    margin: auto;
    margin-top: 20px;
    background: #2c2c2c;
    padding: 10px;
    padding: 20px 15px 20px 15px;
    border-radius: 10px;
    display: flex;
    flex: 1;
    align-items: center;
    .maintenance-title {
      width: 50%;
      text-align: left;
      font: normal normal bold 25px/24px 'CircularStd-Medium';
      letter-spacing: 0px;
      color: white;
      text-transform: capitalize;
      opacity: 1;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      &__text {
        margin-bottom: -2px;
        margin-left: 8px;
      }
    }
    .maintenance-text {
      width: 50%;
      color: white;
      text-transform: uppercase;
      text-align: left;
      font-size: 10px;
      padding-top: 15px;
      a {
        color: #3e7aff;
      }
    }
  }
  &__lab-error {
    color: #727276;
    text-transform: initial;
    font-size: 14px;
  }
}
</style>
